<template>
  <div class="m-token-infos">
    <div class="head flex-left">
      <img :src="infos.icon" alt />
      <span>{{ infos.symbol }}</span>
      <span v-if="infos.nickname">&nbsp;({{ infos.nickname }})</span>
    </div>
    <div class="infos table-shadow">
      <div class="line flex-left">
        <img src="../../../assets/img/tip/red.png" />
        <label>发行总量</label>
        <span>{{ formatTotalSupply(infos) }}</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/pink.png" />
        <label>合约地址</label>
        <!-- <span>{{ infos.address | filterHash }}</span> -->
        <router-link :to="`/contract/${infos.address}`" class="light">{{
          infos.address | filterHash(10)
        }}</router-link>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/green.png" />
        <label>发行时间</label>
        <span>{{ new Date(infos.deploy_time).getTime() | formatTime }}</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/red.png" />
        <label>精度</label>
        <span>{{ infos.decimals || '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infos: {
      type: Object,
      default: () => {
        return {
          icon: "",
          symbol: "",
          total: "",
          holders: "",
          txCount: "",
          createTime: "",
          ceilpoint: "",
          web: ""
        };
      }
    }
  },
  methods: {
    formatTotalSupply(infos) {
      // 优先使用格式化后的总供应量
      if (infos.total_formatted) {
        return Number(infos.total_formatted).toLocaleString();
      }
      // 如果有原始总供应量和小数位数，进行计算
      if (infos.total && infos.decimals) {
        const decimals = infos.decimals || 18;
        const total = Number(infos.total) / Math.pow(10, decimals);
        return total.toLocaleString();
      }
      return '-';
    }
  }
};
</script>

<style lang="scss" scoped>
.m-token-infos {
  .head {
    span {
      margin: 0 4px;
      font-size: 14px;
      color: $black;
    }

    .title {
      color: #9aaab9;
    }

    img {
      height: 23px;
    }
  }

  .infos {
    margin-top: 10px;
    background: $white;
    border: 1px solid rgba(235, 239, 241, 1);
    padding: 10px;
    color: $black;

    .line {
      line-height: 37px;

      label {
        margin-left: 10px;
        width: 6em;
      }
    }
  }
}
</style>